import React from "react"
import { Link } from "../../common/components/link"
import { links } from "../../routes"
import { getExpirationDescription, getRemaningDaysDescription } from "../../login/loginHelpers"



export const SubscriptionExpiringAlert: React.FunctionComponent<{ remainingDays: number }> = ({ remainingDays }) => {
    return (<div className="card">
        <div className="card-body">
            <div className="d-flex flex-wrap justify-content-center align-items-center">
                <div className="d-flex">
                    <div className="round round-lg round-danger me-3">
                        <i className="fas fa-exclamation-triangle" />
                    </div>
                    <div>
                        <div className="fw-bold text-uppercase" style={{ fontSize: "1.1rem" }}>
                            {getExpirationDescription(remainingDays)}
                        </div>
                        <div>Non rimanere senza CaldaieManager</div>
                        {remainingDays >= 0 && <div>
                            <span className="badge bg-danger text-uppercase pulse" style={{ fontSize: "1.5rem" }}>
                                {getRemaningDaysDescription(remainingDays)}
                            </span>
                        </div>}
                    </div>
                </div>
                <div className="me-5 ms-5">
                    <div className="text-primary">
                        <strong style={{ fontSize: "3rem" }}>12€</strong>
                        <span style={{ fontSize: "1.5rem" }}>\mese</span>
                    </div>
                </div>
                <div className="">
                    <Link to={links.paymentPage} className="btn btn-primary btn-lg pulse">
                        <i className="fas fa-shopping-cart me-2" />    Acquista subito
                    </Link>
                </div>
            </div>
        </div>
    </div >
    )
}